import { Button } from '@creditornot/cb-button';
import { Modal } from '@creditornot/cbt-modal';
import { useMutation } from '@tanstack/react-query';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { createOrderApiCredentials } from 'apis/restaurant-api/merchant-admin/order-api-credentials/api';

type ModalProps = {
  merchantId: string;
  isOpen: boolean;
  onClose: () => void;
};

const OrderApiSetupModal = ({ onClose, isOpen, merchantId }: ModalProps) => {
  const intl = useIntl();

  const mutation = useMutation(
    () => {
      return createOrderApiCredentials(merchantId);
    },
    {
      onSuccess: () => {
        onClose();
      },
    },
  );

  return (
    <Modal
      open={isOpen}
      onDismiss={onClose}
      sizePreset="centered:medium"
      title={intl.formatMessage({ id: 'merchant-integrations.order-api.setup' })}
      footer={
        <>
          <Button
            variant="secondary"
            size="small"
            onClick={onClose}
            disabled={mutation.isLoading}
            loading={mutation.isLoading}
          >
            <FormattedMessage id="state.cancel" />
          </Button>

          <Button
            variant="primary"
            size="small"
            disabled={mutation.isLoading}
            loading={mutation.isLoading}
            onClick={() => mutation.mutate()}
          >
            <FormattedMessage id="merchant-integrations.order-api.setup-action" />
          </Button>
        </>
      }
      footerStyle={{
        justifyContent: 'end',
        gap: 16,
      }}
    >
      <FormattedMessage id="merchant-integrations.order-api.setup-confirmation" />
    </Modal>
  );
};

export default OrderApiSetupModal;
